import React, { useMemo } from 'react';
import { TabsCardLayout } from '@icoach/components';
import MemberDetailOtherContentOrderUncheckout from './MemberDetailOtherContentOrderUncheckout';
import MemberDetailOtherContentOrderRecord from './MemberDetailOtherContentOrderRecord';
import MemberDetailOtherContentGiftClaimRecord from '@icoach/memberDetail/MemberDetailOtherContentGiftClaimRecord';
import { isEqual } from '@util/utils';
import useTabState from '@util/hook/useTabState';
import { MEMBER_DETAIL_TABS_MAP } from '@icoach/memberDetail/staticData';

const MemberDetailOtherContent = ({ className, memberID }) => {
    const { activeTab, handleTabChange } = useTabState(MEMBER_DETAIL_TABS_MAP.UNCHECKOUT);
    const tabData = useMemo(
        () => {
            return [
                {
                    label: '欠費訂單',
                    value: MEMBER_DETAIL_TABS_MAP.UNCHECKOUT,
                },
                {
                    label: '購買記錄',
                    value: MEMBER_DETAIL_TABS_MAP.ORDER_RECORD,
                },
                {
                    label: '贈品紀錄',
                    value: MEMBER_DETAIL_TABS_MAP.GIFT_CLAIM,
                },
            ];
        },
        // eslint-disable-next-line
        [],
    );

    return (
        <TabsCardLayout className={className} activeTab={activeTab} tabs={tabData} onTabChange={handleTabChange} tabsContent={{ className: 'pt-3 px-3 pb-3' }}>
            {isEqual(activeTab, MEMBER_DETAIL_TABS_MAP.UNCHECKOUT) && <MemberDetailOtherContentOrderUncheckout memberID={memberID} />}
            {isEqual(activeTab, MEMBER_DETAIL_TABS_MAP.ORDER_RECORD) && <MemberDetailOtherContentOrderRecord memberID={memberID} />}
            {isEqual(activeTab, MEMBER_DETAIL_TABS_MAP.GIFT_CLAIM) && <MemberDetailOtherContentGiftClaimRecord memberID={memberID} />}
        </TabsCardLayout>
    );
};

export default MemberDetailOtherContent;
